import { LayoutHOC } from 'base/ui/layout/layout';
import createStockReceivingAdd from './StockRecevingAdd';

export const createStockReceivingAddPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createStockReceivingAdd());
};